export default __webpack_public_path__ + "static/media/msg.9de01d61.svg";